import setReduxAction from 'modules/redux/actions/set'
import getActionStrReduxUtil from 'modules/redux/utils/get-action-str'
import getValueReduxUtil from 'modules/redux/utils/get-value'
import REDUX_OPTION from 'modules/redux/constants/option'
import {
  PLANS_ACTION,
  PLANS_ENDPOINT,
  PLANS_PATH
} from 'modules/plan/redux/constants/index.js'
import { logUtil } from 'packages/src'
import { logEventAnalyticsUtil } from 'modules/analytics/utils/log-event/index.js'

import {
  loadInstanceReduxAction,
  PLAN_CLASS_NAME
} from '@gymaholic/packages'

const ANALYTIC_EVENT = {
  LOAD_SUGGESTED_PLAN: 'LOAD_SUGGESTED_PLAN'
}

// TODO move to @gymaholic/packages
export default function loadSuggestedPlanAction (options = {}) {
  return async (dispatch) => {
    try {
      logEventAnalyticsUtil(ANALYTIC_EVENT.LOAD_SUGGESTED_PLAN)
      logUtil('loadSuggestedPlanAction').debug('[start]')
      const path = PLANS_PATH.SUGGESTED
      const res = await dispatch(
        loadInstanceReduxAction({
          type: PLANS_ACTION.LOAD_SUGGESTED,
          payload: {
            endpoint: PLANS_ENDPOINT.SUGGESTED,
            path,
            options: {
              [REDUX_OPTION.IS_FORCED]: true,
              ...options
            }
          }
        })
      )

      logUtil('loadSuggestedPlanAction').debug('res=', res)
      const id = getValueReduxUtil(res, 'data.suggestedPlan.id')
      dispatch(
        setReduxAction({
          type: getActionStrReduxUtil('PLANS_ACTIONS_SET_SUGGESTED', id),
          payload: {
            path,
            value: id
          }
        })
      )

      // TODO omit
      // It should be done automatically
      dispatch(
        setReduxAction({
          type: getActionStrReduxUtil('PLANS_ACTIONS_SET_SUGGESTED_CLASS_NAME', id),
          payload: {
            path: `plans.data.${id}.className`,
            value: PLAN_CLASS_NAME
          }
        })
      )

      return id
    } catch (error) {
      logUtil('loadSuggestedPlanAction').error('error=', error)
    }
  }
}
